import { useState } from "react";
import CuDropdown from "../../common_component/component/CuDropdown";
import "../css/ConsultationNextVisit.css";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import { formatDate } from "../../_helper/utils/utils";

const options = [
  { key: 1, value: "days", text: "Days" },
  { key: 2, value: "weeks", text: "Week" },
  { key: 3, value: "months", text: "Month" },
];

const ConsultationNextVisit = ({ nextVisit, setNextVisit }) => {
  const md = useMediaQuery({ query: "(max-width:1024px)" });
  const lg = useMediaQuery({ query: "(max-width:1280px)" });
  const xl = useMediaQuery({ query: "(max-width:1366px)" });
  const [numberOfDays, setNumberOfDays] = useState("");
  const [selectedOption, setSelectedOption] = useState("days");

  const handleOptionChange = (val) => {
    setSelectedOption(val);
    setNextVisit(calculateDate(numberOfDays, val));
  };

  const calculateDate = (amount, unit) => {
    const currentDate = moment();
    return currentDate.add(amount, unit).format("YYYY-MM-DD");
  };

  const handleNumberOfDaysChange = (e) => {
    if (e.target.value > 0) {
      setNextVisit(calculateDate(e.target.value, selectedOption));
      setNumberOfDays(e.target.value);
    } else {
      setNextVisit("");
      setNumberOfDays("");
    }
  };

  return (
    <div className="cu-consultation-nextvisit-container">
      <label className="cu-consultation-nextvisit-label">Next Visit</label>
      <div className="cu-consultation-nextvisit-input-cont">
        <input
          className="cu-consultation-nextvisit-input"
          type={"number"}
          placeholder={"Number of Days"}
          value={numberOfDays}
          onChange={handleNumberOfDaysChange}
        />
        <div className="cu-consultation-nextvisit-options">
          <CuDropdown
            options={options}
            value={selectedOption}
            onChange={handleOptionChange}
            style={{
              height: md
                ? "37.94px"
                : lg
                  ? "35.56px"
                  : xl
                    ? "37.44px"
                    : "53.33px",
            }}
          />
        </div>
        <span>{formatDate(nextVisit)}</span>
      </div>
    </div>
  );
};

export default ConsultationNextVisit;
